export const blog = {
    'meta': {
        'title': 'Blog | COLLIGO',
        'description': 'Blog poruszający tematy związane z psychologią, psychoterapią, psychiatrią, rozwojem osobistym, relacjami międzyludzkimi, a także z psychologią biznesu.'
    },
    'url': {
        'address': '/blog',
        'title': 'Blog | COLLIGO',
        'name': 'Blog'
    },
    'image': {
        'url': '/images/services/diagnostyka-autyzmu-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka autyzmu'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Blog poruszający tematy związane z psychologią, psychoterapią, psychiatrią, rozwojem osobistym, relacjami międzyludzkimi, a także z psychologią biznesu.'
        }
    }
}